import {memo} from 'react';
import {Mail} from 'react-feather';

function Footer() {
  return (
    <footer>
      <div className="link">
        <a href="/" rel="noopener noreferrer">
          police<span>data</span>
        </a>
      </div>

      <h5>
        PoliceData.org is an initiative to collect and publish police use of
        force data nationwide.
      </h5>

      <div className="legal-links">
        <a href="/privacy-policy">Privacy Policy</a>
        <a href="/terms-of-use">Terms of Use</a>
        <a href="/acceptable-use">Acceptable Use</a>
      </div>

      <div className="links">
        <a
          href="mailto:info@policedata.org"
          className="mail"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Mail />
        </a>
      </div>
    </footer>
  );
}

export default memo(Footer);
